import { useState } from "react";
import { Box, IconButton, InputAdornment, Typography } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import CustomTextField from "../../../../components/common/Textfield";

interface Props {
  label: string;
  value?: string | null;
  multiline?: boolean;
  rows?: number;
  masked?: boolean;
  helperText?: string;
}

export default function SensitiveValueField({
  label,
  value,
  multiline = false,
  rows = 3,
  masked = true,
  helperText,
}: Props) {
  const [show, setShow] = useState(false);

  const finalValue = value || "";
  const shouldMask = masked && !show;

  return (
    <Box>
      <CustomTextField
        fullWidth
        label={label}
        value={shouldMask ? "••••••••••••••••••••" : finalValue}
        multiline={multiline}
        rows={multiline ? rows : undefined}
        InputProps={{
          readOnly: true,
          endAdornment: masked ? (
            <InputAdornment position="end">
              <IconButton onClick={() => setShow((prev) => !prev)} edge="end">
                {show ? <VisibilityOffIcon /> : <VisibilityIcon />}
              </IconButton>
            </InputAdornment>
          ) : undefined,
        }}
      />
      {helperText && (
        <Typography variant="caption" color="text.secondary">
          {helperText}
        </Typography>
      )}
    </Box>
  );
}
